import { render, staticRenderFns } from "./ClientSettingsActionsTabpanel.vue?vue&type=template&id=028454f1&"
import script from "./ClientSettingsActionsTabpanel.vue?vue&type=script&lang=js&"
export * from "./ClientSettingsActionsTabpanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028454f1')) {
      api.createRecord('028454f1', component.options)
    } else {
      api.reload('028454f1', component.options)
    }
    module.hot.accept("./ClientSettingsActionsTabpanel.vue?vue&type=template&id=028454f1&", function () {
      api.rerender('028454f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Game/ClientSettingsActionsTabpanel.vue"
export default component.exports